const VoucherType = {
    TOTAL_VOUCHER: 1,
    VOUCHER_NOT_USE_YET: 2,
    TOTAL_MONEY_VOUCHER: 3,
    VOUCHER_EXPIRED: 4,
    VOUCHER_IS_USING: 5,
    VOUCHER_USED: 6,
    VOUCHER_WAITING_USE: 7,
    TOTAL_MONEY_VOUCHER_NOT_USE_YET: 8,
    TOTAL_MONEY_VOUCHER_IS_USING: 9,
    TOTAL_MONEY_VOUCHER_USED: 10,
    VOUCHER_TRANSFERRED: 11,
    PROMOTION: 12
}
export default VoucherType